module.exports = __webpack_public_path__ + "static/service19-d00ee95409e17d626b51c2cf8f0d99c6.jpg";